import { Toaster, ToastReference } from '@economic/taco';
import Qs from 'qs';
import internalApiClient from '../api/internalApiClient';
import { t } from '../../components/l10n/l10n';
import { downloadFile } from './downloadFile';

interface EnumReplacement {
    key: number;
    value: string;
}

interface TextReplacement {
    value: string;
    to: string;
}

export type Columns = {
    accessor: string;
    columnHeader?: string;
    nullAsEmpty?: boolean;
    enumReplacements?: EnumReplacement[];
    textReplacements?: TextReplacement[];
}[];

export default async function ExportToExcel(
    url: string,
    fileName: string,
    data: any[],
    headlines: string[],
    toast: Toaster<ToastReference>,
    columns?: { accessor: string; columnHeader?: string }[]
): Promise<void> {
    const toastRef = toast.loading(t`INBOX_GENERATING_EXPORT_TO_EXCEL`);

    const response = await internalApiClient.post(
        url,
        {
            data,
            headlines,
        },
        {
            responseType: 'blob',
            params: {
                columns,
            },
            paramsSerializer: params => Qs.stringify(params, { allowDots: true }),
        }
    );

    downloadFile(response, fileName);

    toastRef.close();
}

export async function unpaginatedExportToExcel(
    basePath: string,
    dataEndpoint: string,
    exportEndpoint: string,
    filename: string,
    headlines: string[],
    toast: Toaster<ToastReference>,
    columns?: Columns
) {
    const toastRef = toast.loading(t`INBOX_GENERATING_EXPORT_TO_EXCEL`);

    const path = basePath.replace(dataEndpoint, exportEndpoint);

    const response = await internalApiClient.get(path, {
        responseType: 'blob',
        params: {
            columns,
            headlines,
        },
        paramsSerializer: params => {
            if (params) {
                params.returnAll = true;
            }

            return Qs.stringify(params, { allowDots: true });
        },
    });

    downloadFile(response, filename);

    toastRef.close();
}
